import React from "react";
import { Row, Col, Button } from "reactstrap";
import './style.css'
import PassngerIcon from "../../_assets/icons/passenger.svg"
import ArrIcon from "../../_assets/icons/ArrIcon.svg"
import DepIcon from "../../_assets/icons/DepIcon.svg"

const ResultList = ({
    flightDate,
    flightNumber,
    passengerName,
    paxType,
    currency,
    amount,
    basicFare,
    totalFare,
    tscCharge, securityTax, fuelSubcharge, airportTax, airlineName, airlineCode, route, ticketNumber,
}) => {
  return (
    <div className="result-list-container">
      <Row className="text-center mb-4">
        <Col>
        <p className="passenger-found"><img src={PassngerIcon} alt="Passenger" className="mr-2" />Passenger found</p>
          <h6 className="font-weight-bold">{ticketNumber}</h6>
          <p>
          <span><img src={DepIcon} alt="Departure" className="mr-2" />{route.split('-')[0]}</span> &nbsp;||&nbsp;
          <span><img src={ArrIcon} alt="Arrival" className="mr-2" />{route.split('-')[1]}</span>
          </p>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md="3"><strong>Flight date</strong><br />{flightDate}</Col>
        <Col md="3"><strong>Flight number</strong><br />{flightNumber}</Col>
        <Col md="3"><strong>Passenger name</strong><br />{passengerName}</Col>
        <Col md="3"><strong>Pax type</strong><br />{paxType}</Col>

      </Row>
      <Row className="mb-3">
        <Col md="3"><strong>Currency</strong><br />{currency}</Col>
        <Col md="3"><strong>Amount</strong><br />{amount}</Col>
        <Col md="3"><strong>Basic fare</strong><br />{basicFare}</Col>
        <Col md="3"><strong>Total fare</strong><br />{totalFare}</Col>
      </Row>
      <Row className="mb-3">
        <Col md="3"><strong>TSC charge</strong><br />{tscCharge}</Col>
        <Col md="3"><strong>Security tax</strong><br />{securityTax}</Col>
        <Col md="3"><strong>Fuel surcharge</strong><br />{fuelSubcharge}</Col>
        <Col md="3"><strong>Airport tax</strong><br />{airportTax}</Col>
      </Row>
      <Row className="mb-3">
        <Col md="3"><strong>Airline name</strong><br />{airlineName}</Col>
        <Col md="3"><strong>Airline code</strong><br />{airlineCode}</Col>
        <Col md="3"><strong>Route</strong><br />{route}</Col>
        <Col md="3"></Col>
      </Row>
    </div>
  );
};

export default ResultList;



// WEBPACK FOOTER //
// ./src/views/ticket-search/result-list.js